import { ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Breadcrumb, Row, Col, Typography, Spin, Tabs } from 'antd';
import { FaRegCalendar, FaRegCalendarCheck, FaRegFileAlt } from 'react-icons/fa';
import moment from 'moment';

import { stateGlobal } from '../../../../interfaces/Global';

import CardInformacao from '../../components/CardInformacao';
import { IntegracaoComSistemaContabil } from '../../SolicitacoesDeAtivacao/Gerenciar/Tabs/IntegracaoComSistemaContabil';
import { AlinhamentoDeContasEFontes } from '../../SolicitacoesDeAtivacao/Gerenciar/Tabs/AlinhamentoDeContasEFontes';
import { IntegracaoComBancos } from '../../SolicitacoesDeAtivacao/Gerenciar/Tabs/IntegracaoComBancos';
import { PermissoesUsuarios } from '../../SolicitacoesDeAtivacao/Gerenciar/Tabs/PermissoesUsuarios';
import BotoesAtualizar from './components/BotoesBuscar';
import useAdicionarOrgao from './useAdicionarOrgao';

const AdicionarOrgao = () => {

    const {
        orgao,
        isLoadingOrgao,
        handleClickVoltar,
        activeKeyTabs,
        onClickTab,
        handleCreateOrgaoVinculado,
        handleUpdateOrgao,
        handleUpdateOrgaoVinculado,
        handleDeleteOrgaoVinculado,
        requestUpdateSistemaContabil,
        handleUpdateSistemaContabil,
        handleCreateConfiguracaoSistemaContabil,
        handleUpdateConfiguracaoSistemaContabil,
        handleDeleteConfiguracaoSistemaContabil,
        handleConfiguracaoSistemaContabilChange,
        handleUpdateTipoEmpenhosERestos,
        handleTipoEmpenhosERestosChange,
        handleUpdateSistemaContabilIntegrado,
        handleSistemaContabilIntegradoChange,
        handleGetOrdenacaoFontes,
        handleGetFontesOrfas,
        handleGetContasEPlanilha,
        handleUpdateFonteFavorita,
        handleUpdateCategoriaFonte,
        handleUpdateDescricaoFonte,
        handleCreateFonte,
        handleUpdateConta,
        handleCreateConta,
        handleDeleteConta,
        handleEncerrarConta,
        handleDeleteFonte,
        handleUpdateContasFontes,
        handleGetAutorizacoesBancoDoBrasil,
        handleGetContasComErro,
        handleGetContasInativas,
        handleCreateIdAplicacao,
        handleUpdateIdAplicacao,
        handleCreateCredenciais,
        handleUpdateCredenciais,
        handleDeleteAutorizacao,
        handleGetBancosVanBancaria,
        handleUpdateNumeroRequerimentoVan,
        handleCreateCredenciaisVan,
        handleUpdateCredenciaisVan,
        handleGetDocumentoSignedUrlVan,
        handleGetUsuarios,
        handleUpdateCategoriasUsuario,
        handleGetFontes,
        handleGetOrgaosVinculados,
        handleUpdateOrdenacaoFontes,
    } = useAdicionarOrgao();

    const propsState = useSelector((state: stateGlobal) => state.global);

    const dummyHandler = () => { };

    const tabs: Array<{
        key: string;
        ordem: number;
        label: ReactNode;
        children: JSX.Element;
        disabled?: boolean;
    }> = useMemo(() => {
        return [
            {
                key: 'integracao-contabil',
                ordem: 1,
                label: "Órgãos vinculados e sistema contábil",
                children:
                    <>
                        {
                            orgao && (
                                <IntegracaoComSistemaContabil
                                    solicitacao={orgao?.solicitacaoAtivacao!}
                                    orgao={orgao}
                                    isManutencao
                                    onUpdateOrgao={handleUpdateOrgao}
                                    onCreateOrgaoVinculado={handleCreateOrgaoVinculado}
                                    onUpdateOrgaoVinculado={handleUpdateOrgaoVinculado}
                                    onDeleteOrgaoVinculado={handleDeleteOrgaoVinculado}
                                    onEtapaIniciada={dummyHandler}
                                    onEtapaConcluida={dummyHandler}
                                    onUpdateObservacao={dummyHandler}
                                    onUpdateSistemaContabil={handleUpdateSistemaContabil}
                                    onSistemaContabilIntegradoChange={handleSistemaContabilIntegradoChange}
                                    onConfiguracaoSistemaContabilChange={handleConfiguracaoSistemaContabilChange}
                                    onTipoEmpenhosERestosChange={handleTipoEmpenhosERestosChange}
                                    requestUpdateSistemaContabil={requestUpdateSistemaContabil}
                                    onCreateConfiguracaoSistemaContabil={handleCreateConfiguracaoSistemaContabil}
                                    onUpdateConfiguracaoSistemaContabil={handleUpdateConfiguracaoSistemaContabil}
                                    onDeleteConfiguracaoSistemaContabil={handleDeleteConfiguracaoSistemaContabil}
                                    onUpdateTipoEmpenhosERestos={handleUpdateTipoEmpenhosERestos}
                                    onUpdateSistemaContabilIntegrado={handleUpdateSistemaContabilIntegrado}
                                />
                            )
                        }
                    </>
            },
            {
                key: 'alinhamento-contas',
                ordem: 2,
                label: "Fontes e contas",
                children:
                    <AlinhamentoDeContasEFontes
                        solicitacao={orgao?.solicitacaoAtivacao!}
                        onUpdateOrgao={handleUpdateOrgao}
                        onEtapaIniciada={dummyHandler}
                        onEtapaConcluida={dummyHandler}
                        onUpdateObservacao={dummyHandler}
                        onGetOrdenacaoFontes={handleGetOrdenacaoFontes}
                        onGetFontesOrfas={handleGetFontesOrfas}
                        onGetContasEPlanilha={handleGetContasEPlanilha}
                        onUpdateFonteFavorita={handleUpdateFonteFavorita}
                        onUpdateOrdenacaoFontes={handleUpdateOrdenacaoFontes}
                        onUpdateCategoriaFonte={handleUpdateCategoriaFonte}
                        onUpdateDescricaoFonte={handleUpdateDescricaoFonte}
                        onCreateFonte={handleCreateFonte}
                        onUpdateConta={handleUpdateConta}
                        onCreateConta={handleCreateConta}
                        onDeleteConta={handleDeleteConta}
                        onEncerrarConta={handleEncerrarConta}
                        onDeleteFonte={handleDeleteFonte}
                        onUpdateContasFontes={handleUpdateContasFontes}
                        onGetFontes={handleGetFontes}
                        onGetOrgaosVinculados={handleGetOrgaosVinculados}
                        isManutencao
                    />
            },
            {
                key: 'integracao-bancos',
                ordem: 3,
                label: "Bancos",
                children:
                    <IntegracaoComBancos
                        solicitacao={orgao?.solicitacaoAtivacao!}
                        onUpdateOrgao={handleUpdateOrgao}
                        onEtapaIniciada={dummyHandler}
                        onEtapaConcluida={dummyHandler}
                        onUpdateObservacao={dummyHandler}
                        onGetAutorizacoesBancoDoBrasil={handleGetAutorizacoesBancoDoBrasil}
                        onGetContasComErro={handleGetContasComErro}
                        onGetContasInativas={handleGetContasInativas}
                        onCreateIdAplicacao={handleCreateIdAplicacao}
                        onUpdateIdAplicacao={handleUpdateIdAplicacao}
                        onCreateCredenciais={handleCreateCredenciais}
                        onUpdateCredenciais={handleUpdateCredenciais}
                        onDeleteAutorizacao={handleDeleteAutorizacao}
                        onGetBancosVanBancaria={handleGetBancosVanBancaria}
                        onUpdateNumeroRequerimentoVan={handleUpdateNumeroRequerimentoVan}
                        onCreateCredenciaisVan={handleCreateCredenciaisVan}
                        onUpdateCredenciaisVan={handleUpdateCredenciaisVan}
                        onGetDocumentoVanSignedUrl={handleGetDocumentoSignedUrlVan}
                        isManutencao
                    />
            },
            {
                key: 'definicao-permissoes',
                ordem: 4,
                label: "Permissões",
                children:
                    <PermissoesUsuarios
                        solicitacao={orgao?.solicitacaoAtivacao!}
                        onUpdateOrgao={handleUpdateOrgao}
                        onEtapaIniciada={dummyHandler}
                        onEtapaConcluida={dummyHandler}
                        onUpdateObservacao={dummyHandler}
                        onGetUsuarios={handleGetUsuarios}
                        onUpdateCategoriasUsuario={handleUpdateCategoriasUsuario}
                        isManutencao
                    />
            }
        ]
    }, [
        orgao,
        handleUpdateOrgao,
        handleCreateOrgaoVinculado,
        handleUpdateOrgaoVinculado,
        handleDeleteOrgaoVinculado,
        handleCreateConfiguracaoSistemaContabil,
        handleUpdateConfiguracaoSistemaContabil,
        handleDeleteConfiguracaoSistemaContabil,
        handleUpdateTipoEmpenhosERestos,
        handleUpdateSistemaContabilIntegrado,
        handleGetOrdenacaoFontes,
        handleGetContasEPlanilha,
        handleUpdateFonteFavorita,
        handleUpdateCategoriaFonte,
        handleUpdateDescricaoFonte,
        handleCreateFonte,
        handleUpdateConta,
        handleCreateConta,
        handleDeleteConta,
        handleGetAutorizacoesBancoDoBrasil,
        handleGetContasComErro,
        handleGetContasInativas,
        handleCreateIdAplicacao,
        handleUpdateIdAplicacao,
        handleCreateCredenciais,
        handleUpdateCredenciais,
        handleDeleteAutorizacao,
        handleGetUsuarios,
        handleUpdateCategoriasUsuario,
        handleGetFontes,
        handleGetOrgaosVinculados,
        handleUpdateOrdenacaoFontes,
    ]);

    return (
        <Spin
            spinning={isLoadingOrgao}
        >
            <Row
                gutter={[6, 12]}
            >
                <Col
                    xs={24}
                    lg={7}
                    xl={7}
                    span={7}
                >
                    <Typography.Title level={3} style={{ marginBottom: 0 }}>
                        {'Manutenção de Ativação'}
                    </Typography.Title>

                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <a
                                onClick={handleClickVoltar}
                            >
                                {'Manutenção de Ativações'}
                            </a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>{'Manutenção de Ativação'}</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>

                <Col
                    xs={24}
                    lg={17}
                    xl={17}
                    span={17}
                >
                    <Row gutter={[8, 8]}>
                        <Col
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={8}
                            span={8}
                        >
                            <CardInformacao
                                IconComponent={FaRegFileAlt}
                                title="CONTRATO"
                                value={orgao?.solicitacaoAtivacao?.contrato.nome || "--"}
                            />
                        </Col>

                        <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={8}
                            span={8}
                        >
                            <CardInformacao
                                IconComponent={FaRegCalendar}
                                title="DATA DE SOLICITAÇÂO"
                                value={orgao?.solicitacaoAtivacao?.createdAt ? moment(orgao.solicitacaoAtivacao?.createdAt).format('DD/MM/YYYY HH:mm') : '--'}
                            />
                        </Col>

                        <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={8}
                            span={8}
                        >
                            <CardInformacao
                                IconComponent={FaRegCalendarCheck}
                                title="DATA DE CONCLUSÃO"
                                value={orgao?.solicitacaoAtivacao.concluidaEm ? moment(orgao?.solicitacaoAtivacao.concluidaEm).format('DD/MM/YYYY HH:mm') : "--"}
                                iconBackgroundColor={propsState.theme === 'light' ? '#d6f9e6' : '#18432E'}
                                iconColor={"#00B153"}
                            />
                        </Col>
                    </Row>
                </Col>

                <BotoesAtualizar
                    orgao={orgao}
                />

                <Col span={24}>
                    <Tabs
                        activeKey={activeKeyTabs}
                        onChange={onClickTab}
                        defaultActiveKey="1"
                        type="card"
                        style={{ width: "100%", marginTop: 15 }}
                        tabBarStyle={{ marginBottom: 0 }}
                        key={"tabsSolicitacoesAtivacao"}
                        items={tabs}
                    />
                </Col>
            </Row>
        </Spin>
    );
}


export default AdicionarOrgao;
